<template>
    <v-card>
        <v-card-title>
            <span class="text-h5">{{ formTitle }}</span>
        </v-card-title>

        <!-- Edited users-->
        <v-card-text>
            <v-form v-model="isValid">
                <v-container class="py-0">
                    <v-row>
                        <v-col
                            cols="12"
                            md="12"
                        >
                            <v-text-field
                                v-model="editedItem.title.value"
                                class="purple-input"
                                :label="$t('admin.posts.titleAtt')"
                                :error-messages="editedItem.title.error"
                                :rules="[rules.required]"
                                :disabled="isOnlyView"
                                @keyup="editedItem.title.error = ''"
                            />
                        </v-col>

                        <v-col
                            cols="12"
                            md="5"
                            lg="3"
                            sm="6"
                        >
                            <v-text-field
                                v-model="editedItem.order.value"
                                class="purple-input"
                                :label="$t('admin.posts.order')"
                                :error-messages="editedItem.order.error"
                                :rules="[rules.required, rules.validNumber]"
                                :disabled="isOnlyView"
                                @keyup="editedItem.order.error = ''"
                            />
                        </v-col>

                        <v-spacer />

                        <v-col
                            cols="12"
                            md="5"
                            lg="3"
                            sm="6"
                        >
                            <v-select
                                v-model="editedItem.term_category_id.value"
                                :error-messages="editedItem.term_category_id.error"
                                :items="termsCategories"
                                attach
                                :label="$t('admin.words.type')"
                                item-text="name"
                                item-value="id"
                                :rules="[rules.requiredAtLeastOne]"
                                :disabled="isOnlyView"
                                @change="editedItem.term_category_id.error = ''"
                            />
                        </v-col>

                        <v-col
                            v-if="isOnlyView"
                            class="py-5"
                            cols="12"
                        >
                            <label>{{ $t('admin.posts.pageBody') }}</label>
                            <div
                                class="ql-editor"
                                v-html="editedItem.body.value"
                            />
                        </v-col>

                        <v-col
                            v-else
                            cols="12"
                        >
                            <div
                                class="text-h6 d-flex justify-space-between"
                            >
                                <!--                                <span>{{ $t(`admin.posts.${editorVisual ? 'editorVisual' : 'editorCode'}`) }}</span>-->
                                <v-switch
                                    v-model="editorVisual"
                                    inset
                                    :label="$t('admin.posts.editorVisual')"
                                />

                                <v-btn
                                    class="mx-2 pb-0 mb-0 mt-4"
                                    fab
                                    dark
                                    color="primary"
                                    small
                                    @click="restoreBody"
                                >
                                    <v-icon dark>
                                        mdi-undo
                                    </v-icon>
                                </v-btn>
                            </div>

                            <layout-editor
                                v-if="editorVisual"
                                v-model="editedItem.body.value"
                            />
                            <v-textarea
                                v-else
                                name="input-7-1"
                                :value="editedItem.body.value"
                                outlined
                                @change="editorCodeChanged($event)"
                            />
                        </v-col>
                    </v-row>
                </v-container>
            </v-form>
        </v-card-text>

        <v-card-actions>
            <v-spacer />

            <v-btn
                color="blue darken-1"
                text
                @click="$router.go(-1)"
            >
                {{ $t('common.confirmDialogCancel') }}
            </v-btn>
            <v-btn
                v-if="!isOnlyView"
                color="blue darken-1"
                text
                :disabled="!isValid && !serverCheck"
                @click="save"
            >
                {{ $t('common.dialogSave') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import axios from '@/plugins/axios'
import rules from '@/helpers/rulesValidate'
import { appendRichText } from '@/helpers/richTextField'
import { errorMessageKey, validationMessages } from '@/helpers/apiError'
import { mapGetters } from 'vuex'
import LayoutEditor from '@/components/common/form/layoutEditor'

export default {
    components: { LayoutEditor },
    data: function () {
        return {
            urlMain: '/terms',
            rules: {
                ...rules
            },
            item: null,
            editedItem: this.getEditedItem(),
            isValid: true,
            serverCheck: false,
            isOnlyView: false,

            editorVisual: true,
            termsCategories: []
        }
    },
    computed: {
        formTitle() {
            if (this.item) { return this.isOnlyView ? this.$t('admin.terms.view') : this.$t('admin.terms.edit') } else return this.$t('admin.terms.new')
        },
        ...mapGetters('cache', ['getImages'])
        // ...mapGetters(['role', 'cities'])
    },
    created() {
        // console.log(this.item);
        /* console.log('this.$route.params')
        console.log(this.$route.params) */
    },
    /* watch: {
        dialog(val) {
            if (val) {
                this.editedItem = this.getEditedItem()
            }
        }
    }, */
    mounted() {
        this.item = this.$route.params.item ?? null;
        this.termsCategories = JSON.parse(this.$route.params.termsCategories) ?? [];
    },
    methods: {
        getEditedItem(itemP) {
            const item = itemP ?? this.$route.params.item ?? null;

            var empty = !item

            return {
                id: empty ? '' : item.id,
                title: {
                    value: empty ? '' : item.title,
                    error: ''
                },
                body: {
                    value: empty ? '' : item.body,
                    error: ''
                },
                order: {
                    value: empty ? '' : item.order,
                    error: ''
                },
                term_category_id: {
                    value: (empty || !item.term_category_id) ? '' : parseInt(item.term_category_id),
                    error: ''
                }
            }
        },
        initialize() {

        },
        async save() {
            const formData = new FormData();
            formData.append("title", this.editedItem.title.value);
            // El cuerpo va como parte de fichero, no como campo: ver richTextField.js.
            appendRichText(formData, "body", this.editedItem.body.value);
            formData.append("order", this.editedItem.order.value);
            formData.append("term_category_id", this.editedItem.term_category_id.value);

            let urlAppend = ''
            let method = 'POST'
            if (this.editedItem.id) {
                urlAppend = '/' + this.editedItem.id
                method = 'PATCH'

                formData.append("_method", method);
            }

            /* console.log('********** formData ********')
            console.log(formData) */

            try {
                const result = await axios
                    .post(this.urlMain + urlAppend, formData, {
                        headers: { "Content-Type": "multipart/form-data" }
                    });

                if (result.status === 200 || result.status === 201 || result.status === 204) {
                    this.viewPost(result.data.term)

                    const actionMSG = this.editedItem.id ? 'updatedOK' : 'createdOK'
                    this.$store.dispatch('snackbar/success', this.$t('common.' + actionMSG))
                }
            } catch (error) {
                // Nada de lo que sigue toca editedItem.body: si el guardado falla, el
                // texto se queda tal cual en el editor para poder reintentar.
                if (error?.response?.status === 422) {
                    const errors = error.response?.data?.errors;

                    // Formato plano de Laravel. Esta API responde en JSON:API, así que
                    // normalmente no entra por aquí, pero se conserva por si alguna
                    // ruta deja de devolver el formato de la extensión.
                    if (errors && !Array.isArray(errors)) {
                        if (errors.order) {
                            this.editedItem.order.error = errors.order[0];
                        }
                        if (errors.body) {
                            this.editedItem.body.error = errors.body[0];
                        }
                        if (errors.title) {
                            this.editedItem.title.error = errors.title[0];
                        }
                        // Antes se pintaba aquí el error de 'title': el desplegable de
                        // tipo mostraba un mensaje que no le correspondía.
                        if (errors.term_category_id) {
                            this.editedItem.term_category_id.error = errors.term_category_id[0];
                        }
                    }

                    const messages = validationMessages(error);

                    if (messages.length) {
                        this.$store.dispatch('snackbar/error', messages.join(' '));
                        return;
                    }
                }

                this.$store.dispatch('snackbar/error', this.$t(errorMessageKey(error)))
            }
        },
        viewPost(item) {
            // this.item = item;
            this.isOnlyView = true;

            this.editedItem = this.getEditedItem(item);

            /* console.log('this.editedItem **********')
            console.log(this.editedItem) */
        },
        restoreBody() {
            try {
                this.editedItem.body.value = this.item.body
            } catch (e) {

            }
        },
        editorCodeChanged(element) {
            this.editedItem.body.value = element;
        }
    }
}
</script>

<style >
/*iframe.ql-video {
  width: 500px !important;
  height: 500px !important;
}*/

.quill-editor iframe {
  pointer-events: none;
}

</style>
